import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rating flex flex-nowrap items-center w-full justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.41616 23.1641C4.8365 23.462 4.18015 22.9413 4.29685 22.2761L5.54144 15.1819L0.257945 10.1469C-0.235826 9.67639 0.019774 8.81605 0.681258 8.72208L8.02897 7.67827L11.3052 1.18846C11.6003 0.603848 12.3997 0.603848 12.6948 1.18846L15.971 7.67827L23.3187 8.72208C23.9802 8.81605 24.2358 9.67639 23.7421 10.1469L18.4586 15.1819L19.7031 22.2761C19.8198 22.9413 19.1635 23.462 18.5838 23.1641L12 19.7802L5.41616 23.1641Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
      return _createElementVNode("div", {
        key: i,
        class: _normalizeClass(["mr-2", i <= _ctx.number ? 'text-yellow-400' : 'text-neutral-200'])
      }, _hoisted_3, 2)
    }), 64))
  ]))
}